export default {
  title: "L'importation est en cours... 🙂",
  description: "Des notifications Slack seront envoyées à la fin de l'importation.",
  buttons: {
    open_followers_list: 'Ouvrir la liste des abonnés',
  },
};
